import { render } from "./about.vue?vue&type=template&id=45c3bcc4&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=45c3bcc4&scoped=true&lang=css"

import exportComponent from "E:\\工作\\新旅视界网络科技有限公司\\达人令\\webapp\\drl-live-jk\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c3bcc4"]])

export default __exports__